import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import Header from "./Header";

import bg from "../assets/register-image.jpg"; 
import logo from "../assets/urban people white.png";

import "./Login.css";
import "./OrganizationRegister.css"; // New CSS file for layout

const ORG_FIELDS = [
  { label: "Organization Name", name: "organizationName", type: "text", required: true, placeholder: "Enter organization name" },
  { label: "Admin Username", name: "username", type: "text", required: true, placeholder: "Create username" },
  { label: "Password", name: "password", type: "password", required: true, placeholder: "Create password" },
  { label: "Email", name: "email", type: "email", placeholder: "example@company.com" },
  { label: "Phone", name: "phone", type: "text", placeholder: "Enter phone number" },
];

export default function OrganizationRegister() {
  const navigate = useNavigate();
  const [form, setForm] = useState({
    organizationName: "",
    username: "",
    password: "",
    email: "",
    phone: "",
    address: "",
    orgId: "",
  });

  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  const handleChange = e =>
    setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async e => {
    e.preventDefault();
    setLoading(true);
    setMessage("");

    try {
      const res = await fetch("https://hrms.urbango.co.in/server/index.php?endpoint=organization-register", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });

      const data = await res.json();
      if (data?.success) setMessage("✔ Organization registered successfully!");
      else setMessage("❌ " + (data?.message || "Registration failed"));
    } catch (err) {
      setMessage("❌ Server error");
    }

    setLoading(false);
  };

  return (
    <>
      {/* Header stays */}
      <Header />

      {/* Full background */}
      <div className="org-bg">
        <img src={bg} alt="Background" className="org-bg-img" />

      

        {/* Container */}
        <div className="org-container">
          <div className="org-card">

            <img src={logo} className="org-logo" alt="Logo" />
            <h2 className="org-title">Organization Registration</h2>

            {message && <div className="org-msg">{message}</div>}

            <form onSubmit={handleSubmit} className="org-grid-form">
              
              {/* Organization ID */}
              <div className="col">
                <label className="login-label">Organization ID *</label>
                <input
                  className="login-input"
                  name="orgId"
                  type="text"
                  maxLength={10}
                  pattern="[A-Za-z0-9]{1,10}"
                  value={form.orgId}
                  onChange={handleChange}
                  placeholder="Unique ID (max 10 chars)"
                  required
                />
              </div>

              {/* Auto map remaining fields */}
              {ORG_FIELDS.map(f => (
                <div className="col" key={f.name}>
                  <label className="login-label">{f.label} {f.required && "*"}</label>
                  <input
                    className="login-input"
                    name={f.name}
                    type={f.type}
                    value={form[f.name]}
                    onChange={handleChange}
                    required={!!f.required}
                    placeholder={f.placeholder}
                  />
                </div>
              ))}

              {/* Address full width */}
              <div className="col-full">
                <label className="login-label">Address</label>
                <input
                  className="login-input"
                  name="address"
                  rows={1}
                  value={form.address}
                  onChange={handleChange}
                  placeholder="Full address include city, state, zip"
                />
              </div>

              <div className="col-full">
                <button
                  className="login-btn"
                  type="submit"
                  disabled={loading}
                >
                  {loading ? "Registering..." : "Register Organization"}
                </button>
              </div>

            </form>

            {/* Back to login */}
            <button
              className="org-back"
              onClick={() => navigate("/login")}
            >
              ← Back to Login
            </button>

          </div>
        </div>
      </div>
    </>
  );
}
